import React, { useState } from "react";
import { Link } from "react-router-dom";

const SideNav = () => {
    const [isSectionOpen, setIsSectionOpen] = useState(false);
    const [isNewsEventSpeechOpen, setIsNewsEventSpeechOpen] = useState(false);

    const toggleSection = () => {
        setIsSectionOpen(!isSectionOpen);
    };

    const toggleNewsEventSpeech = () => {
        setIsNewsEventSpeechOpen(!isNewsEventSpeechOpen);
    };

    return (
        <div className="bg-gray-800 text-white w-64 h-screen p-4">
            <ul className="space-y-4">
                <li>
                    <Link to="/" className="hover:bg-gray-700 p-2 block rounded">
                        Dashboard
                    </Link>
                </li>
                <li>
                    <Link to="/users" className="hover:bg-gray-700 p-2 block rounded">
                        Users
                    </Link>
                </li>
                <li>
                    <button onClick={toggleNewsEventSpeech} className="hover:bg-gray-700 p-2 block rounded">
                        NewsEventSpeech
                    </button>
                    {isNewsEventSpeechOpen && (
                        <ul className="pl-4 space-y-2">
                            <li>
                                <Link to="/news-event-speech" className="hover:bg-gray-700 p-2 block rounded">
                                    Create News/Event/Speech
                                </Link>
                            </li>
                            <li>
                                <Link to="/all-news-event-speech" className="hover:bg-gray-700 p-2 block rounded">
                                    All NewsEventSpeech
                                </Link>
                            </li>
                            <li>
                                <Link to="/news" className="hover:bg-gray-700 p-2 block rounded">
                                    News
                                </Link>
                            </li>
                            <li>
                                <Link to="/event" className="hover:bg-gray-700 p-2 block rounded">
                                    Event
                                </Link>
                            </li>
                            <li>
                                <Link to="/speech" className="hover:bg-gray-700 p-2 block rounded">
                                    Speech
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li>
                    <button onClick={toggleSection} className="hover:bg-gray-700 p-2 block rounded">
                        Sections
                    </button>
                    {isSectionOpen && (
                        <ul className="pl-4 space-y-2">
                            <li>
                                <Link to="/first_section" className="hover:bg-gray-700 p-2 block rounded">
                                    Section 1
                                </Link>
                            </li>
                            <li>
                                <Link to="/section/2" className="hover:bg-gray-700 p-2 block rounded">
                                    Section 2
                                </Link>
                            </li>
                            <li>
                                <Link to="/section/3" className="hover:bg-gray-700 p-2 block rounded">
                                    Section 3
                                </Link>
                            </li>
                        </ul>
                    )}
                </li>
                <li>
                    <Link to="/settings" className="hover:bg-gray-700 p-2 block rounded">
                        Settings
                    </Link>
                </li>
            </ul>
        </div>
    );
};

export default SideNav;